import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { intlShape } from 'react-intl'

import { getPlaylist as getPlaylistAction } from './playlistActions'
import * as selectors from './playlistSelectors'
import * as shapes from '../../constant/shapes'
import redirectToApp from '../../utils/redirectToApp'
import appConst from '../../constant/appConst'
import TrackList from '../../components/tracklist/TrackList'
import { Link } from 'react-router'
import { clearPlayqueue as clearPlayqueueAction } from '../../components/miniPlayer/AudioPlayer/playerActions'
import Loader from '../../components/loader/Loader'
import { Helmet } from 'react-helmet'

const fields = [{
	type: 'cover',
	render: track => <img src={track.cover} alt="" height="40" width="40" />
},{
	type: 'name',
	render: track => <Link to={`/track/${track.id}`}>{track.title}</Link>
}, {
	type: 'artist',
	render: track => {
		let artistId = ''
		let artistName = ''

		if (track.id) {
			if (track.performer) {
				artistId = track.performer.id
				artistName = track.performer.name
			} else {
				artistId = track.artistId
				artistName = track.artist
			}
		}
		return (<Link to={`/artist/${artistId}`}>{artistName}</Link>)
	}
}, {
	type: 'album',
	render: track => <Link to={`/album/${track.albumId}`}>{track.album}</Link>
}, {
	type: 'label',
	render: track => <span>{track.label}</span>
}, {
	type: 'time',
	render: track => `${`0${Math.floor(track.duration / 60)}`.substr(-2)}:${`0${track.duration % 60}`.substr(-2)}`
}]

const getPlaylistCovers = (images300) => {
	const playlistImages = []
	if (images300) {
		if (images300.length === 3) {
			// on affiche les 3 cover
			let i
			for (i = 0; i < 3; i++) {
				playlistImages.push(images300[i])
			}
		} else {
			// on affiche 4 covers quitte à repeter plusieurs fois les mêmes
			let j
			for (j = 0; j < 4; j++) {
				playlistImages.push(images300[j % images300.length])
			}
		}
	}
	return playlistImages
}

class PlaylistPage extends PureComponent {

	componentWillMount() {
		const { id, getPlaylist } = this.props
		getPlaylist(id)
		this.state = {
			fullDescription: false
		}
		this.toggleFullDescription = this.toggleFullDescription.bind(this)
	}

	componentWillUnmount() {
		this.props.clearPlayqueue()
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.id !== nextProps.id) this.props.clearPlayqueue()
	}


	toggleFullDescription() {
		this.setState({
			fullDescription: !this.state.fullDescription
		})
	}

	render() {
		const { id, infos } = this.props
		const { intl } = this.context

		const { duration } = infos

		const showDisplayFull = !this.state.fullDescription && (infos.description || '').length > appConst.descriptionMaxLength
		let description = ''
		if (infos.description) {
			if (showDisplayFull) {
				const maxPos = infos.description.lastIndexOf(' ', appConst.descriptionMaxLength)
				description = `${infos.description.substring(0, maxPos)}...`
			} else {
				description = infos.description
			}
		}

		let dureeAffichee
		if (duration > 3600) {
			dureeAffichee = intl.formatMessage(
				{ id: 'infos.duration.long' },
				{ hours: `${Math.floor(duration/3600)}`, minutes: `${Math.floor((duration % 3600)/60)}` }
			)
		} else {
			dureeAffichee = intl.formatMessage(
				{ id: 'infos.duration.short' },
				{ minutes: `${Math.floor(duration/60)}`, seconds: `${duration % 60}` }
			)
		}

		const playlistImages = getPlaylistCovers(infos.images)
		const playlistSpecialImage = infos.image_rectangle
		let cssForCover
		if (playlistSpecialImage) {
			cssForCover = 'rectangle'
		} else {
			cssForCover = playlistImages.length > 0 ? `cover-${playlistImages.length}` : 'no-cover'
		}

		return (
			<Loader>
				<div className="content mt40">
					<Helmet>
						<title>{intl.formatMessage({ id: "title.playlist" }, { playlistName: infos.name, ownerName: infos.owner })}</title>
					</Helmet>
					<div className={`item-playlist-background ${cssForCover}`}>
						{playlistSpecialImage ?
							<span key="background-playlist-item" style={{ backgroundImage: `url(${playlistSpecialImage})` }} />
							: playlistImages.map((image, i) =>
								<span key={`background-playlist-item-${i}`} style={{ backgroundImage: `url(${image})` }} />
							)}
					</div>
					<div className="playlist-background-overlay" />
					<div className="container">
						<div className="row">
							<div className="col-md-12">
								<div className="playlist-cover-content">
									<div className={`item-cover-playlist ${cssForCover}`}>
										{playlistSpecialImage ?
											<span key="user-playlist-cover-small" style={{ backgroundImage: `url(${playlistSpecialImage})` }} className="playlist-cover" />
											: playlistImages.map((image, i) =>
												<span key={`user-playlist-cover-small-${i}`} style={{ backgroundImage: `url(${image})` }} className="playlist-cover" />
											)}
									</div>
								</div>
								<div className="text-center mb50">
									<h1 className="t4 text-bold mb10">{infos.name}</h1>
									<p className="t2 mb0">{intl.formatMessage({ id: 'focus.from' }, { author: infos.owner })}</p>
									{infos.genres && infos.genres.length ? <p className="text-shadow c1 t6 mb15">{infos.genres.join(' / ')}</p> : <p />}
									<p className="c2 mb20">
										<span className="pct pct-track" /> {intl.formatMessage({ id: 'infos.trackCount' }, { count: `${infos.tracksCount}` })}
										<span className="pct pct-circle-wait ml10" /> {dureeAffichee}
									</p>
									<a onClick={() => redirectToApp('playlist', id)} className="bt7">{intl.formatMessage({ id: 'buttons.listen' })}</a>
								</div>
								<p {...(!this.state.fullDescription ? { className: 'playlist-desc' } : {})}
									dangerouslySetInnerHTML={{ __html: (description ? `${description}` : '').nl2br() }}
								/>
								{showDisplayFull && <p className="mb80">
									<a onClick={this.toggleFullDescription} className="c2">
										{intl.formatMessage({ id: 'buttons.readmore' })}
										&nbsp;<span className="pct pct-carret-link t7" />
									</a>
								</p>}
								{this.state.fullDescription && <p>
									<a onClick={this.toggleFullDescription} className="c2">
										<span className="pct pct-reverse-carret-link t7" />&nbsp;
										{intl.formatMessage({ id: 'buttons.showless' })}
									</a>
								</p>}
								<div className="item-list">
									<h2 className="t2 c2 mb20">{intl.formatMessage({ id: 'tracklist.title.playlist' })}</h2>
									<TrackList
										fields={fields}
										listContainerClassName="playlist-tracks-list"
										listClassName="track-list full-list no-cache no-more"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Loader>
		)
	}

}

PlaylistPage.propTypes = {
	id: PropTypes.string,
	infos: shapes.playlist,
	getPlaylist: PropTypes.func,
	clearPlayqueue: PropTypes.func
}

PlaylistPage.contextTypes = {
	intl: intlShape
}

const mapStateToProps = (state, ownProps) => ({
	id: ownProps.params.id,
	infos: selectors.getPlaylistInfos(state)
})

const actions = {
	getPlaylist: getPlaylistAction,
	clearPlayqueue: clearPlayqueueAction
}

export default connect(mapStateToProps, actions)(PlaylistPage)



// WEBPACK FOOTER //
// ./src/pages/playlist/PlaylistPage.jsx